// hooks/useIsRootPage.ts
import {useState, useEffect} from "react"
import {useLocation} from "@reach/router"

export const useIsRootPage = () => {
	const location = useLocation()
	const [isRootPage, setIsRootPage] = useState(false)

	useEffect(() => {
		setIsRootPage(location.pathname === "/")
	}, [location])

	return isRootPage
}
